<template>
    <v-container>
      <rental-form schema="new" title="NUEVO ALQUILER" />
    </v-container>
  </template>
  
  <script>
  import RentalForm from "../../components/Forms/rentalForm.vue";

  export default {
    components: { RentalForm },
  };
  </script>
  
  <style></style>
  